import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  effect,
} from '@angular/core';
import { QueryLoadingState } from '@globalconnect/query';
import {
  IpoLanguageService,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import { saveAs } from 'file-saver';
import { Observable, Subject } from 'rxjs';
import { InstallationReportingV2Service } from '../../../installation-reporting-app/service/sdu/installation-reporting-v2.service';
import { InstallationReportOrderDetail } from '../../../shared/installation-report-content-v2/installation-report-content-entities';
import { InstallationReportFilterService } from '../../../shared/installation-report-content-v2/service/installation-report-filter.service';
import {
  onErrorDownloadExcel,
  onSuccessDownloadExcel,
} from '../../../shared/installation-report-content-v2/utils/handle-gcquery-request';
import {
  RP_DOWNLOAD_ORDERS_OVERVIEW_EXCEL,
  RP_ORDERS_OVERVIEW_DOWNLOADED,
  RP_ORDERS_OVERVIEW_DOWNLOAD_CLICKED,
  RP_ORDERS_OVERVIEW_FILTER_SEARCH,
} from '../../../shared/posthug-analytics/analytics-event-types';
import { AnalyticsService } from '../../../shared/posthug-analytics/analytics.service';
import { ToastsService } from '../../../shared/toast/toast.service';
import { ResourcesService } from '../../../user/resources.service';
@Component({
  selector: 'app-orders-overview-modal',
  templateUrl: './orders-overview-modal.component.html',
  styleUrls: ['./orders-overview-modal.component.scss'],
  standalone: false,
})
export class OrdersOverviewModalComponent implements OnInit, OnDestroy {
  @Input() ifs: string;
  @Output() dismiss = new EventEmitter();

  language$ = this.languageService.getLanguage$();
  cancelSubs$ = new Subject<void>();
  selectedProject$ = this.resourceService.getSelectedResource$();
  installationReportingResponse$: Observable<
    QueryLoadingState<InstallationReportOrderDetail[]>
  >;

  isDownloading = false;

  filterText = '';
  activePage: number;

  filterFields = [
    'orderDetail.locationInformation.streetName',
    'orderDetail.locationInformation.city',
    'orderDetail.contactInformation.firstName',
    'orderDetail.contactInformation.lastName',
  ];

  constructor(
    private languageService: IpoLanguageService,
    private resourceService: ResourcesService,
    private analyticsService: AnalyticsService,
    private installationReportingServiceV2: InstallationReportingV2Service,
    private toastService: ToastsService,
    private translate: IpoTranslatePipe,
    private filterService: InstallationReportFilterService,
  ) {
    this.activePage = this.filterService.activePage();
    effect(() => {
      this.activePage = this.filterService.activePage();
    });
  }

  ngOnInit(): void {
    this.getSelectedProject();
  }

  ngOnDestroy(): void {
    this.cancelSubs$.next();
  }

  getSelectedProject() {
    this.selectedProject$.subscribe((selectedProject) => {
      if (selectedProject) {
        this.installationReportingResponse$ =
          this.installationReportingServiceV2.getDeliveryItems$(
            selectedProject.value,
          );
      }
    });
  }

  onFilterTextChanged(filter: string) {
    if (this.filterText === '') {
      this.analyticsService.logEvent(RP_ORDERS_OVERVIEW_FILTER_SEARCH);
    }
    this.filterText = filter;
    this.filterService.onChangePage(0);
  }

  closeModal() {
    this.dismiss.emit();
  }

  onDownloadExcel() {
    this.isDownloading = true;
    this.installationReportingServiceV2.createExcelFile(this.ifs, {
      onSuccess: (data) => {
        onSuccessDownloadExcel(this.toastService, this.translate, () =>
          this.handleDownloadExcelResult(data),
        );
        this.analyticsService.logEvent(RP_ORDERS_OVERVIEW_DOWNLOADED);
      },
      onError: () => {
        onErrorDownloadExcel(this.toastService, this.translate, () =>
          this.handleDownloadExcelResult(),
        );
      },
    });
    this.analyticsService.logEvent(RP_DOWNLOAD_ORDERS_OVERVIEW_EXCEL, {
      ifs: this.ifs,
    });
    this.analyticsService.logEvent(RP_ORDERS_OVERVIEW_DOWNLOAD_CLICKED);
  }

  handleDownloadExcelResult(data?: { fileName: string; file: Blob }) {
    data && saveAs(data.file, 'orders-overview-' + data.fileName);
    this.isDownloading = false;
  }
}
